import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Notification from '../../components/sharedComponents/Notification';
import * as notificationActions from '../../actions/notification/notificationActions';
import { getActiveNotificationType } from '../../selectors/notification';

class NotificationContainer extends React.PureComponent {
    static propTypes = {
        /** Notification data, from redux */
        notifications: PropTypes.shape({
            error: PropTypes.shape({
                display: PropTypes.bool,
                message: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
            }),
            warning: PropTypes.shape({
                display: PropTypes.bool,
                message: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
            }),
            success: PropTypes.shape({
                display: PropTypes.bool,
                message: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
            })
        }),
        /** Alert type, from redux */
        type: PropTypes.string,

        /** Fires the dismissNotification action creator */
        dismissNotification: PropTypes.func.isRequired,

        /** If true, the alert will gain focus when it mounts, which will
         * automatically cause the page to scroll to the notification and screen
         * readers will read the notification */
        shouldFocusOnMount: PropTypes.bool
    };

    static defaultProps = {
        notifications: { error: { display: false, message: '' } },
        type: "error",
        shouldFocusOnMount: true
    };

    dismissNotification = () => {
        const { dismissNotification, type } = this.props;

        dismissNotification(type);
    }

    render() {
        const { type, notifications, ...otherProps } = this.props;
        const activeNotification = notifications[type];

        if (!activeNotification.display) {
            return null;
        }

        return (
            <Notification
                type={type}
                dismissNotification={this.dismissNotification}
                {...otherProps}>
                {activeNotification.message}
            </Notification>
        );
    }
}


const mapStateToProps = (state) => ({
    type: getActiveNotificationType(state.notifications),
    notifications: state.notifications
});

const mapDispatchToProps = (dispatch) => ({
    dismissNotification: (type) => dispatch(notificationActions.dismissNotification(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationContainer);
